import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AuthorizationService, TranslationService } from '@mirage-projects/cw-commons';
import { ResponseErrorCodes } from '@mirage-projects/cw-models';

/**
 * This interceptor is responsible to intercept all the server responses that contain a license error
 * and it redirects to the home page
 */
@Injectable({ providedIn: 'root' })
export class ResponseInterceptor implements HttpInterceptor {
    private RESPONSE_ERROR_CODES: string[];

    constructor(
        private authorizationService: AuthorizationService,
        private injector: Injector
    ) {
        this.RESPONSE_ERROR_CODES = this.responseErrorCodesToConst();
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap((evt) => this.checkErrorCode(evt)),
            catchError((err: HttpEvent<any>) => {
                const translatedError = this.translateErrors(err);
                this.errorResponse(translatedError);
                return throwError(() => this.translateErrors(err));
            })
        );
    }

    private checkErrorCode(evt: HttpEvent<any>): void {
        if (evt && evt instanceof HttpResponse) {
            if (this.RESPONSE_ERROR_CODES.includes(evt.body?.code)) {
                this.authorizationService.appLogout({ error: evt.body.code });
            }
        }
    }

    private errorResponse(errEvt: any): void {
        if (errEvt && errEvt instanceof HttpErrorResponse) {
            if (this.RESPONSE_ERROR_CODES.includes(errEvt.error?.code)) {
                this.authorizationService.appLogout({ error: errEvt.error.code });
            }
        }
    }

    private responseErrorCodesToConst(): string[] {
        return Object.keys(ResponseErrorCodes).map((element: string): string => element);
    }

    private translateErrors(event: HttpEvent<any>): HttpEvent<any> {
        const isError = event && event instanceof HttpErrorResponse;

        const errorKey: string = isError ? event.error?.code : undefined;

        if (!this.RESPONSE_ERROR_CODES.includes(errorKey)) {
            return event;
        }

        const translationService = this.injector.get(TranslationService);

        const magnetErrorKey = `MAGNET.${errorKey}`;
        const isErrorTranslated = errorKey && translationService.existKey(magnetErrorKey);

        if (isErrorTranslated) {
            (event as any).statusText = translationService.translate('GENERAL.ERROR');
            (event as any).message = translationService.translate(magnetErrorKey);
        }

        return event;
    }
}
